/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Enrollment, PaymentAndTaxStatus, PayoutReport, Invitation } from "../../models/model";
import { Metadata } from "@emt/emt-metadata-client";
import { emptyMetadata } from "../reducers/metadata";

export interface EnrollmentAppStore {
    enrollments: Enrollment[];
    invitations: Invitation[];
    payoutReports: PayoutReport[];
    bankAndTaxStatuses: PaymentAndTaxStatus[];
    metadata: Metadata;
    dataFetchingStatus: DataFetchingStatus;
    errorStatus: ErrorStatus;
    canShowWobo: boolean;
}

export class DataFetchingStatus {
    metadata: boolean = false;
    bankAndTax: boolean = false;
    enrollment: boolean = false;
    invitation: boolean = false;
    localization: boolean = false;
    payoutReports: boolean = false;
}

export class ErrorStatus {
    metadata: boolean = false;
    bankAndTax: boolean = false;
    invitation: boolean = false;
    payoutReports: boolean = false;
    enrollment: boolean = false;
    localization: boolean = false;
}

export class Link {
    text: string;
    url: string;
}

export class TableContent {
    programName: string;
    location: string;
    paidEarnings: string;
    unpaidEarnings: string;
    totalEarnings: string;
    status: string;
    links: Link[];
}

export class EnrollmentState implements EnrollmentAppStore {
    enrollments = [];
    invitations = [];
    bankAndTaxStatuses = [];
    payoutReports = [];
    metadata: Metadata = emptyMetadata;
    dataFetchingStatus = new DataFetchingStatus();
    errorStatus = new ErrorStatus();
    canShowWobo = false;
}
